<div class="sprint-review-details">
  <div class="details-header">
    <h4 class="details-title">Sprint reviews del mes</h4>
    <div class="details-summary">
      <span class="summary-pill completed">{{ completedReviewsCount() }} hecho{{ completedReviewsCount() === 1 ? '' : 's' }}</span>
      @if (upcomingReviewsCount() > 0) {
        <span class="summary-pill upcoming">{{ upcomingReviewsCount() }} previsto{{ upcomingReviewsCount() === 1 ? '' : 's' }}</span>
      }
    </div>
  </div>

  @if (sprintReviews().length === 0) {
    <p class="no-data">No hay sprint reviews programadas en este período.</p>
  } @else {
    <div class="reviews-list">
      @for (review of sprintReviews(); track review.date) {
        <div
          class="review-row"
          [class.completed]="review.status === EmployeeCalendarRegisterStatus.COMPLETED"
          [class.upcoming]="review.status === EmployeeCalendarRegisterStatus.UPCOMING"
        >
          <div class="review-main">
            <mat-icon class="review-status-icon">
              {{ review.status === EmployeeCalendarRegisterStatus.COMPLETED ? 'check_circle' : 'event' }}
            </mat-icon>
            <span class="review-date">{{ review.date | date: 'EEEE d LLL y' : '' : 'es-ES' }}</span>
          </div>

          <div class="review-meta">
            @if (review.status === EmployeeCalendarRegisterStatus.COMPLETED) {
              <span class="review-participants">
                <mat-icon>group</mat-icon>
                {{ review.participants_count }} participante{{ review.participants_count === 1 ? '' : 's' }}
              </span>
            } @else {
              <span class="review-pending-label">Pendiente</span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
